export interface ComicChapter {
  id: string;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  tags: string[];
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  updateDate: string;
  chapters: ComicChapter[];
}

export const allComics: Comic[] = [
  {
    id: 'comic-1',
    slug: 'wo-de-jie-fu',
    title: '我的姐夫',
    author: '极直',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%2C%20young%20man%20and%20woman%20in%20modern%20Seoul%20apartment%2C%20emotional%20atmosphere%2C%20warm%20lighting%2C%20soft%20pastel%20color%20palette%2C%20clean%20illustration%20style%2C%20romantic%20drama%20vibe%2C%20webtoon%20art%20style%2C%20simple%20background%20with%20warm%20interior%20setting&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '姐姐结婚后，我以为我的人生会平静下去。直到有一天，姐夫对我说了一句让我无法忽视的话...一段禁忌又心动的罗曼史就此展开。当亲情与爱情交织，她该如何抉择？',
    category: 'love',
    tags: ['恋爱', '都市', '禁忌'],
    rating: 4.8,
    views: 1250000,
    status: '连载中',
    updateDate: '2026-07-08',
    chapters: [
      { id: 'ch1-1', title: '第1话 初次见面', updateDate: '2026-06-01' },
      { id: 'ch1-2', title: '第2话 意外的告白', updateDate: '2026-06-04' },
      { id: 'ch1-3', title: '第3话 心跳加速', updateDate: '2026-06-08' },
      { id: 'ch1-4', title: '第4话 秘密', updateDate: '2026-06-12' },
      { id: 'ch1-5', title: '第5话 选择', updateDate: '2026-06-16' },
      { id: 'ch1-6', title: '第6话 靠近', updateDate: '2026-06-20' },
      { id: 'ch1-7', title: '第7话 真相', updateDate: '2026-06-24' },
      { id: 'ch1-8', title: '第8话 无法回头', updateDate: '2026-06-28' },
      { id: 'ch1-9', title: '第9话 告白', updateDate: '2026-07-02' },
      { id: 'ch1-10', title: '第10话 答案', updateDate: '2026-07-06' },
    ],
  },
  {
    id: 'comic-2',
    slug: 'she-ji-you-xi',
    title: '射击游戏',
    author: '金道镇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20action%20comic%20cover%2C%20soldier%20with%20rifle%20in%20urban%20combat%20scene%2C%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20military%20action%20theme%2C%20clean%20webtoon%20illustration%2C%20intense%20stare%2C%20smoke%20and%20debris%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '曾是特种部队王牌狙击手的他，因一次任务失败被迫隐姓埋名。当他以为可以过上平凡生活时，过去的阴影再次笼罩。一场关乎生死的射击游戏，就此拉开帷幕。',
    category: 'action',
    tags: ['动作', '军事', '悬疑'],
    rating: 4.6,
    views: 980000,
    status: '连载中',
    updateDate: '2026-07-07',
    chapters: [
      { id: 'ch2-1', title: '第1话 退役', updateDate: '2026-05-15' },
      { id: 'ch2-2', title: '第2话 暗流涌动', updateDate: '2026-05-20' },
      { id: 'ch2-3', title: '第3话 追杀令', updateDate: '2026-05-25' },
      { id: 'ch2-4', title: '第4话 绝境', updateDate: '2026-05-30' },
      { id: 'ch2-5', title: '第5话 反击', updateDate: '2026-06-05' },
      { id: 'ch2-6', title: '第6话 盟友', updateDate: '2026-06-10' },
      { id: 'ch2-7', title: '第7话 潜入', updateDate: '2026-06-15' },
      { id: 'ch2-8', title: '第8话 对决', updateDate: '2026-06-20' },
    ],
  },
  {
    id: 'comic-3',
    slug: 'mo-fa-shao-nu',
    title: '魔法少女的退休生活',
    author: '李智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%2C%20magical%20girl%20with%20sparkling%20wand%20in%20modern%20city%2C%20bright%20vibrant%20colors%2C%20starry%20magical%20effects%2C%20whimsical%20atmosphere%2C%20cute%20art%20style%2C%20fantasy%20elements%20blending%20with%20reality%2C%20clean%20webtoon%20illustration&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '拯救世界三十年之后，曾经的魔法少女决定退休。可是普通人的生活哪有那么简单？不会用智能手机、不知道什么叫KPI，还要应付时不时冒出来的新魔王...史上最强退休生活，爆笑开启！',
    category: 'fantasy',
    tags: ['奇幻', '搞笑', '日常'],
    rating: 4.9,
    views: 2100000,
    status: '已完结',
    updateDate: '2026-07-01',
    chapters: [
      { id: 'ch3-1', title: '第1话 退休申请', updateDate: '2026-01-10' },
      { id: 'ch3-2', title: '第2话 第一天上班', updateDate: '2026-01-15' },
      { id: 'ch3-3', title: '第3话 KPI是什么', updateDate: '2026-01-20' },
      { id: 'ch3-4', title: '第4话 新魔王登场', updateDate: '2026-01-25' },
      { id: 'ch3-5', title: '第5话 加班地狱', updateDate: '2026-01-30' },
      { id: 'ch3-6', title: '第6话 同事的秘密', updateDate: '2026-02-05' },
      { id: 'ch3-7', title: '第7话 魔法VS职场', updateDate: '2026-02-10' },
      { id: 'ch3-8', title: '第8话 最终话 新的开始', updateDate: '2026-02-15' },
    ],
  },
  {
    id: 'comic-4',
    slug: 'zai-hun-zhe',
    title: '再婚者',
    author: '宋智浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20drama%20comic%20cover%2C%20elegant%20woman%20in%20wedding%20dress%20with%20complicated%20expression%2C%20luxurious%20interior%20setting%2C%20emotional%20atmosphere%2C%20soft%20dramatic%20lighting%2C%20mature%20romance%20theme%2C%20clean%20webtoon%20art%2C%20sophisticated%20color%20palette&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '失去挚爱的她，在三年后决定再婚。然而新婚生活并非想象中那般美好，丈夫隐藏的秘密、继女的敌意、前夫的突然出现...一个再婚女人的挣扎与成长。',
    category: 'love',
    tags: ['恋爱', '家庭', '剧情'],
    rating: 4.7,
    views: 890000,
    status: '连载中',
    updateDate: '2026-07-06',
    chapters: [
      { id: 'ch4-1', title: '第1话 婚礼', updateDate: '2026-04-01' },
      { id: 'ch4-2', title: '第2话 新家', updateDate: '2026-04-06' },
      { id: 'ch4-3', title: '第3话 继女', updateDate: '2026-04-11' },
      { id: 'ch4-4', title: '第4话 裂痕', updateDate: '2026-04-16' },
      { id: 'ch4-5', title: '第5话 前任', updateDate: '2026-04-21' },
      { id: 'ch4-6', title: '第6话 真相', updateDate: '2026-04-26' },
    ],
  },
  {
    id: 'comic-5',
    slug: 'shen-zhi-jue-xing',
    title: '神之觉醒',
    author: '赵敏俊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20action%20comic%20cover%2C%20warrior%20with%20glowing%20divine%20powers%20surrounded%20by%20ancient%20ruins%2C%20epic%20scale%2C%20dramatic%20god%20rays%20lighting%2C%20mythological%20elements%2C%20powerful%20aura%2C%20clean%20webtoon%20illustration%2C%20golden%20and%20crimson%20color%20scheme&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '普通高中生在一次意外中觉醒了沉睡千年的神之血脉。从此，他的世界天翻地覆。神界、魔界、人间，三界的平衡因他而动摇。他能否掌控这股力量，还是会被力量吞噬？',
    category: 'fantasy',
    tags: ['奇幻', '战斗', '升级'],
    rating: 4.5,
    views: 1560000,
    status: '连载中',
    updateDate: '2026-07-05',
    chapters: [
      { id: 'ch5-1', title: '第1话 意外', updateDate: '2026-03-01' },
      { id: 'ch5-2', title: '第2话 觉醒', updateDate: '2026-03-06' },
      { id: 'ch5-3', title: '第3话 神界之门', updateDate: '2026-03-11' },
      { id: 'ch5-4', title: '第4话 试炼', updateDate: '2026-03-16' },
      { id: 'ch5-5', title: '第5话 第一个敌人', updateDate: '2026-03-21' },
      { id: 'ch5-6', title: '第6话 盟友', updateDate: '2026-03-26' },
      { id: 'ch5-7', title: '第7话 魔界入侵', updateDate: '2026-04-01' },
      { id: 'ch5-8', title: '第8话 决战前夕', updateDate: '2026-04-06' },
    ],
  },
  {
    id: 'comic-6',
    slug: 'xiao-yuan-mi-mi',
    title: '校园的秘密',
    author: '韩夏天',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20school%20mystery%20comic%20cover%2C%20students%20in%20school%20uniform%20in%20dark%20classroom%2C%20suspenseful%20atmosphere%2C%20moonlight%20through%20window%2C%20thriller%20vibe%2C%20clean%20webtoon%20illustration%2C%20mysterious%20shadows%2C%20cool%20blue%20and%20dark%20tone&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '转学到新学校的她，发现这所学校隐藏着不可告人的秘密。午夜钟声后的音乐教室、禁止进入的地下室、失踪的学生...每一步接近真相，都离危险更近一步。',
    category: 'thriller',
    tags: ['悬疑', '校园', '惊悚'],
    rating: 4.4,
    views: 720000,
    status: '已完结',
    updateDate: '2026-06-30',
    chapters: [
      { id: 'ch6-1', title: '第1话 转学生', updateDate: '2026-03-01' },
      { id: 'ch6-2', title: '第2话 奇怪的校规', updateDate: '2026-03-06' },
      { id: 'ch6-3', title: '第3话 午夜的音乐', updateDate: '2026-03-11' },
      { id: 'ch6-4', title: '第4话 地下室', updateDate: '2026-03-16' },
      { id: 'ch6-5', title: '第5话 失踪者', updateDate: '2026-03-21' },
      { id: 'ch6-6', title: '第6话 真相大白', updateDate: '2026-03-26' },
      { id: 'ch6-7', title: '第7话 最终话 黎明', updateDate: '2026-03-31' },
    ],
  },
  {
    id: 'comic-7',
    slug: 'tian-ming-zhi-zi',
    title: '天命之子',
    author: '尹道贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20martial%20arts%20comic%20cover%2C%20young%20warrior%20in%20traditional%20hanbok%20with%20sword%2C%20ancient%20Korean%20palace%20background%2C%20cherry%20blossoms%2C%20epic%20wuxia%20atmosphere%2C%20dramatic%20wind%20effects%2C%20clean%20webtoon%20illustration%2C%20elegant%20color%20palette&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '武林至尊陨落后，江湖陷入混乱。一个出身卑微的少年，背负着天命之子的预言踏上征程。在刀光剑影的江湖中，他将如何书写自己的传奇？',
    category: 'action',
    tags: ['动作', '武侠', '奇幻'],
    rating: 4.3,
    views: 680000,
    status: '连载中',
    updateDate: '2026-07-04',
    chapters: [
      { id: 'ch7-1', title: '第1话 预言', updateDate: '2026-04-10' },
      { id: 'ch7-2', title: '第2话 出山', updateDate: '2026-04-15' },
      { id: 'ch7-3', title: '第3话 初战', updateDate: '2026-04-20' },
      { id: 'ch7-4', title: '第4话 名门', updateDate: '2026-04-25' },
      { id: 'ch7-5', title: '第5话 试炼之塔', updateDate: '2026-05-01' },
      { id: 'ch7-6', title: '第6话 宿敌', updateDate: '2026-05-06' },
    ],
  },
  {
    id: 'comic-8',
    slug: 'du-shen-gui-lai',
    title: '赌神归来',
    author: '姜太浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20gambling%20thriller%20comic%20cover%2C%20handsome%20man%20in%20suit%20holding%20playing%20cards%20in%20luxury%20casino%2C%20tense%20atmosphere%2C%20dramatic%20spotlight%2C%20high%20stakes%20theme%2C%20clean%20webtoon%20illustration%2C%20red%20and%20gold%20color%20scheme&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '曾经横扫赌坛的传奇赌神，因一场阴谋失去一切。十年后，他以全新身份重返赌坛。这一次，他不仅要赢回一切，更要揭开当年的真相。',
    category: 'thriller',
    tags: ['悬疑', '赌博', '复仇'],
    rating: 4.6,
    views: 1100000,
    status: '连载中',
    updateDate: '2026-07-07',
    chapters: [
      { id: 'ch8-1', title: '第1话 归来', updateDate: '2026-05-01' },
      { id: 'ch8-2', title: '第2话 第一场赌局', updateDate: '2026-05-06' },
      { id: 'ch8-3', title: '第3话 故人', updateDate: '2026-05-11' },
      { id: 'ch8-4', title: '第4话 阴谋的线索', updateDate: '2026-05-16' },
      { id: 'ch8-5', title: '第5话 地下赌场', updateDate: '2026-05-21' },
      { id: 'ch8-6', title: '第6话 生死局', updateDate: '2026-05-26' },
    ],
  },
  {
    id: 'comic-9',
    slug: 'chong-sheng-zhi-zun',
    title: '重生之至尊',
    author: '金光洙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20reincarnation%20fantasy%20comic%20cover%2C%20powerful%20protagonist%20with%20magical%20aura%20in%20medieval%20fantasy%20world%2C%20magic%20circles%20and%20runes%2C%20epic%20fantasy%20atmosphere%2C%20dramatic%20lighting%2C%20clean%20webtoon%20illustration%2C%20purple%20and%20gold%20magical%20effects&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '一代至尊在渡劫失败后，带着记忆重生于百年之前。熟悉的历史、曾经的敌人、未解的遗憾...这一次，他要改写一切，成为真正的至尊！',
    category: 'fantasy',
    tags: ['奇幻', '重生', '升级'],
    rating: 4.7,
    views: 1890000,
    status: '连载中',
    updateDate: '2026-07-08',
    chapters: [
      { id: 'ch9-1', title: '第1话 陨落', updateDate: '2026-05-15' },
      { id: 'ch9-2', title: '第2话 重回少年', updateDate: '2026-05-19' },
      { id: 'ch9-3', title: '第3话 第一步', updateDate: '2026-05-23' },
      { id: 'ch9-4', title: '第4话 故人相逢', updateDate: '2026-05-27' },
      { id: 'ch9-5', title: '第5话 秘境', updateDate: '2026-06-01' },
      { id: 'ch9-6', title: '第6话 突破', updateDate: '2026-06-05' },
      { id: 'ch9-7', title: '第7话 仇人', updateDate: '2026-06-10' },
      { id: 'ch9-8', title: '第8话 宗门大比', updateDate: '2026-06-15' },
      { id: 'ch9-9', title: '第9话 扬名', updateDate: '2026-06-20' },
      { id: 'ch9-10', title: '第10话 危机', updateDate: '2026-06-25' },
    ],
  },
  {
    id: 'comic-10',
    slug: 's-ji-mi-mi-ren-wu',
    title: 'S级秘密任务',
    author: '朴宰范',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20spy%20action%20comic%20cover%2C%20secret%20agent%20in%20black%20suit%20with%20high%20tech%20gadgets%2C%20futuristic%20city%20night%20background%2C%20neon%20lights%2C%20cyberpunk%20atmosphere%2C%20intense%20action%20theme%2C%20clean%20webtoon%20illustration%2C%20dark%20blue%20and%20neon%20pink%20color%20scheme&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '国家情报院的王牌特工接到一生中最危险的任务——潜入国际犯罪组织。没有支援、没有退路，他必须在敌人眼皮底下完成任务。当身份即将暴露，他该如何抉择？',
    category: 'action',
    tags: ['动作', '谍战', '悬疑'],
    rating: 4.5,
    views: 870000,
    status: '连载中',
    updateDate: '2026-07-03',
    chapters: [
      { id: 'ch10-1', title: '第1话 任务下达', updateDate: '2026-05-20' },
      { id: 'ch10-2', title: '第2话 潜入', updateDate: '2026-05-25' },
      { id: 'ch10-3', title: '第3话 接头', updateDate: '2026-05-30' },
      { id: 'ch10-4', title: '第4话 危机', updateDate: '2026-06-04' },
      { id: 'ch10-5', title: '第5话 双面间谍', updateDate: '2026-06-09' },
      { id: 'ch10-6', title: '第6话 逃亡', updateDate: '2026-06-14' },
    ],
  },
  {
    id: 'comic-11',
    slug: 'tian-cai-yi-sheng',
    title: '天才医生',
    author: '许俊浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20medical%20drama%20comic%20cover%2C%20young%20doctor%20in%20white%20coat%20in%20modern%20hospital%2C%20professional%20atmosphere%2C%20bright%20clean%20lighting%2C%20medical%20theme%2C%20determined%20expression%2C%20clean%20webtoon%20illustration%2C%20soft%20blue%20and%20white%20color%20palette&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '拥有超乎常人医学天赋的他，年仅二十五岁就成为最年轻的主治医师。然而医院里的权力斗争、疑难杂症、生离死别，考验的不仅是医术，更是人心。',
    category: 'love',
    tags: ['恋爱', '医疗', '都市'],
    rating: 4.4,
    views: 650000,
    status: '已完结',
    updateDate: '2026-06-20',
    chapters: [
      { id: 'ch11-1', title: '第1话 第一天', updateDate: '2026-03-01' },
      { id: 'ch11-2', title: '第2话 第一台手术', updateDate: '2026-03-06' },
      { id: 'ch11-3', title: '第3话 对手', updateDate: '2026-03-11' },
      { id: 'ch11-4', title: '第4话 选择', updateDate: '2026-03-16' },
      { id: 'ch11-5', title: '第5话 最终话 仁心', updateDate: '2026-03-21' },
    ],
  },
  {
    id: 'comic-12',
    slug: 'mo-jie-tian-xia',
    title: '魔界天下',
    author: '崔真浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20dark%20fantasy%20comic%20cover%2C%20demon%20lord%20on%20throne%20in%20hellish%20landscape%2C%20epic%20dark%20atmosphere%2C%20flames%20and%20shadows%2C%20demonic%20creatures%2C%20powerful%20villain%20protagonist%2C%20clean%20webtoon%20illustration%2C%20crimson%20and%20black%20color%20scheme&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '人类王国被魔界入侵后，沦为魔族的奴隶。一个拥有半魔血统的少年，在人类与魔族之间挣扎求生。他能否统一魔界，创造人与魔共存的世界？',
    category: 'fantasy',
    tags: ['奇幻', '暗黑', '战斗'],
    rating: 4.8,
    views: 2300000,
    status: '连载中',
    updateDate: '2026-07-08',
    chapters: [
      { id: 'ch12-1', title: '第1话 奴隶', updateDate: '2026-02-01' },
      { id: 'ch12-2', title: '第2话 觉醒', updateDate: '2026-02-06' },
      { id: 'ch12-3', title: '第3话 逃亡', updateDate: '2026-02-11' },
      { id: 'ch12-4', title: '第4话 魔界入口', updateDate: '2026-02-16' },
      { id: 'ch12-5', title: '第5话 第一战', updateDate: '2026-02-21' },
      { id: 'ch12-6', title: '第6话 魔王', updateDate: '2026-02-26' },
      { id: 'ch12-7', title: '第7话 联盟', updateDate: '2026-03-03' },
      { id: 'ch12-8', title: '第8话 叛徒', updateDate: '2026-03-08' },
      { id: 'ch12-9', title: '第9话 决战', updateDate: '2026-03-13' },
      { id: 'ch12-10', title: '第10话 新王登基', updateDate: '2026-03-18' },
      { id: 'ch12-11', title: '第11话 人界使者', updateDate: '2026-03-23' },
      { id: 'ch12-12', title: '第12话 和平之路', updateDate: '2026-03-28' },
    ],
  },
  {
    id: 'comic-13',
    slug: 'ba-dao-zong-cai-ai-shang-wo',
    title: '霸道总裁爱上我',
    author: '林智秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%2C%20handsome%20CEO%20in%20luxury%20office%20with%20city%20skyline%20view%2C%20romantic%20atmosphere%2C%20elegant%20female%20lead%2C%20soft%20warm%20lighting%2C%20clean%20webtoon%20illustration%2C%20sophisticated%20office%20romance%20theme&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    description: '刚毕业的职场菜鸟，误打误撞成为了集团总裁的私人助理。冷漠外表下的温柔、强势背后的孤独...当霸道总裁的真面目一点点展现，她的心也开始沦陷。',
    category: 'love',
    tags: ['恋爱', '都市', '职场'],
    rating: 4.6,
    views: 1430000,
    status: '连载中',
    updateDate: '2026-07-07',
    chapters: [
      { id: 'ch13-1', title: '第1话 面试', updateDate: '2026-04-01' },
      { id: 'ch13-2', title: '第2话 第一天上班', updateDate: '2026-04-06' },
      { id: 'ch13-3', title: '第3话 加班夜', updateDate: '2026-04-11' },
      { id: 'ch13-4', title: '第4话 出差', updateDate: '2026-04-16' },
      { id: 'ch13-5', title: '第5话 醉酒之后', updateDate: '2026-04-21' },
      { id: 'ch13-6', title: '第6话 绯闻', updateDate: '2026-04-26' },
      { id: 'ch13-7', title: '第7话 情敌登场', updateDate: '2026-05-01' },
      { id: 'ch13-8', title: '第8话 他的过去', updateDate: '2026-05-06' },
    ],
  },
  {
    id: 'comic-14',
    slug: 'ge-bi-de-mao-xi-nan-you',
    title: '隔壁的猫系男友',
    author: '姜素拉',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romantic%20comedy%20comic%20cover%2C%20handsome%20young%20man%20with%20cat%20ears%20in%20cozy%20apartment%2C%20playful%20atmosphere%2C%20bright%20warm%20lighting%2C%20cute%20romance%20theme%2C%20clean%20webtoon%20illustration%2C%20pastel%20color%20palette&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    description: '新搬来的邻居是个超级大帅哥，但他有个奇怪的秘密——他其实是一只猫变的！时而高冷时而粘人的猫系男友，让她的日常生活变得鸡飞狗跳又甜蜜无比。',
    category: 'love',
    tags: ['恋爱', '搞笑', '奇幻'],
    rating: 4.7,
    views: 1780000,
    status: '连载中',
    updateDate: '2026-07-06',
    chapters: [
      { id: 'ch14-1', title: '第1话 新邻居', updateDate: '2026-05-10' },
      { id: 'ch14-2', title: '第2话 猫的秘密', updateDate: '2026-05-14' },
      { id: 'ch14-3', title: '第3话 同居生活', updateDate: '2026-05-18' },
      { id: 'ch14-4', title: '第4话 猫咪吃醋', updateDate: '2026-05-22' },
      { id: 'ch14-5', title: '第5话 相亲风波', updateDate: '2026-05-26' },
      { id: 'ch14-6', title: '第6话 第一次约会', updateDate: '2026-05-30' },
      { id: 'ch14-7', title: '第7话 他的真心', updateDate: '2026-06-04' },
      { id: 'ch14-8', title: '第8话 猫咪家族', updateDate: '2026-06-08' },
    ],
  },
  {
    id: 'comic-15',
    slug: 'chu-lian-shi-ka-fei-wei-de',
    title: '初恋是咖啡味的',
    author: '朴秀敏',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%2C%20young%20barista%20couple%20in%20cozy%20coffee%20shop%2C%20warm%20afternoon%20sunlight%2C%20steaming%20coffee%20cups%2C%20sweet%20atmosphere%2C%20clean%20webtoon%20illustration%2C%20soft%20brown%20and%20cream%20color%20palette&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    description: '父母留下的老旧咖啡馆面临倒闭危机，她决定拼死守护。就在此时，一位天才咖啡师走进了她的生活。苦涩与甜蜜交织的咖啡香气中，初恋的味道悄然弥漫。',
    category: 'love',
    tags: ['恋爱', '治愈', '美食'],
    rating: 4.5,
    views: 820000,
    status: '已完结',
    updateDate: '2026-06-15',
    chapters: [
      { id: 'ch15-1', title: '第1话 最后的咖啡馆', updateDate: '2026-02-01' },
      { id: 'ch15-2', title: '第2话 神秘咖啡师', updateDate: '2026-02-06' },
      { id: 'ch15-3', title: '第3话 手冲的秘诀', updateDate: '2026-02-11' },
      { id: 'ch15-4', title: '第4话 竞争对手', updateDate: '2026-02-16' },
      { id: 'ch15-5', title: '第5话 咖啡大赛', updateDate: '2026-02-21' },
      { id: 'ch15-6', title: '第6话 最终话 新的早晨', updateDate: '2026-02-26' },
    ],
  },
  {
    id: 'comic-16',
    slug: 'qi-yue-hun-yin',
    title: '契约婚姻',
    author: '权娜拉',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20drama%20romance%20comic%20cover%2C%20elegant%20couple%20in%20wedding%20attire%20with%20tense%20expressions%2C%20luxurious%20mansion%20background%2C%20dramatic%20atmosphere%2C%20contract%20marriage%20theme%2C%20clean%20webtoon%20illustration%2C%20muted%20gold%20and%20burgundy%20tones&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    description: '为了拯救家族企业，她与一个完全陌生的男人签下了为期一年的婚姻契约。原以为只是逢场作戏，却在朝夕相处中，假戏真做。一年的期限将至，两颗心却已无法分开。',
    category: 'love',
    tags: ['恋爱', '豪门', '剧情'],
    rating: 4.8,
    views: 1950000,
    status: '连载中',
    updateDate: '2026-07-08',
    chapters: [
      { id: 'ch16-1', title: '第1话 契约', updateDate: '2026-04-15' },
      { id: 'ch16-2', title: '第2话 新婚生活', updateDate: '2026-04-20' },
      { id: 'ch16-3', title: '第3话 婆婆驾到', updateDate: '2026-04-25' },
      { id: 'ch16-4', title: '第4话 危机', updateDate: '2026-04-30' },
      { id: 'ch16-5', title: '第5话 第一次心动', updateDate: '2026-05-05' },
      { id: 'ch16-6', title: '第6话 前女友', updateDate: '2026-05-10' },
      { id: 'ch16-7', title: '第7话 家族晚宴', updateDate: '2026-05-15' },
      { id: 'ch16-8', title: '第8话 选择', updateDate: '2026-05-20' },
    ],
  },
  {
    id: 'comic-17',
    slug: 'an-ye-lie-shou',
    title: '暗夜猎手',
    author: '郑宇镇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20vigilante%20action%20comic%20cover%2C%20masked%20hero%20on%20rooftop%20at%20night%2C%20city%20lights%20below%2C%20dramatic%20moonlight%2C%20dark%20atmosphere%2C%20crime%20fighting%20theme%2C%20clean%20webtoon%20illustration%2C%20black%20and%20crimson%20color%20scheme&width=600&height=800&seq=comic-cover-17&orientation=portrait',
    description: '白天是温和的图书馆管理员，夜晚却化身令罪犯闻风丧胆的暗夜猎手。在法律的灰色地带，他用自己方式伸张正义。然而，一场精心策划的陷阱正等着他...',
    category: 'action',
    tags: ['动作', '悬疑', '正义'],
    rating: 4.5,
    views: 1050000,
    status: '连载中',
    updateDate: '2026-07-05',
    chapters: [
      { id: 'ch17-1', title: '第1话 双重生活', updateDate: '2026-03-01' },
      { id: 'ch17-2', title: '第2话 第一次行动', updateDate: '2026-03-06' },
      { id: 'ch17-3', title: '第3话 媒体追逐', updateDate: '2026-03-11' },
      { id: 'ch17-4', title: '第4话 警察的怀疑', updateDate: '2026-03-16' },
      { id: 'ch17-5', title: '第5话 模仿者', updateDate: '2026-03-21' },
      { id: 'ch17-6', title: '第6话 陷阱', updateDate: '2026-03-26' },
    ],
  },
  {
    id: 'comic-18',
    slug: 'ji-jia-zhan-shi',
    title: '机甲战士',
    author: '孙泰英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mecha%20sci-fi%20comic%20cover%2C%20giant%20robot%20in%20futuristic%20battlefield%2C%20explosions%20and%20sparks%2C%20epic%20scale%2C%20mechanical%20details%2C%20clean%20webtoon%20illustration%2C%20metallic%20silver%20and%20electric%20blue%20color%20scheme&width=600&height=800&seq=comic-cover-18&orientation=portrait',
    description: '地球遭到外星机械生命体入侵，人类最后的希望寄托在十台巨型机甲上。一个毫无经验的少年意外成为了最强机甲的驾驶员，他必须在战火中快速成长为拯救世界的英雄。',
    category: 'action',
    tags: ['动作', '科幻', '机甲'],
    rating: 4.4,
    views: 920000,
    status: '连载中',
    updateDate: '2026-07-04',
    chapters: [
      { id: 'ch18-1', title: '第1话 入侵之日', updateDate: '2026-05-01' },
      { id: 'ch18-2', title: '第2话 机甲启动', updateDate: '2026-05-06' },
      { id: 'ch18-3', title: '第3话 首次战斗', updateDate: '2026-05-11' },
      { id: 'ch18-4', title: '第4话 战友', updateDate: '2026-05-16' },
      { id: 'ch18-5', title: '第5话 母舰攻略', updateDate: '2026-05-21' },
      { id: 'ch18-6', title: '第6话 最后的机甲', updateDate: '2026-05-26' },
      { id: 'ch18-7', title: '第7话 真相', updateDate: '2026-06-01' },
      { id: 'ch18-8', title: '第8话 总攻', updateDate: '2026-06-06' },
    ],
  },
  {
    id: 'comic-19',
    slug: 'quan-huang-zhi-lu',
    title: '拳皇之路',
    author: '刘在勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fighting%20sports%20comic%20cover%2C%20young%20boxer%20in%20ring%20with%20sweat%20and%20determination%2C%20dramatic%20spotlight%2C%20intense%20atmosphere%2C%20boxing%20gloves%2C%20clean%20webtoon%20illustration%2C%20red%20and%20black%20color%20scheme&width=600&height=800&seq=comic-cover-19&orientation=portrait',
    description: '从小在贫民窟长大的少年，唯一的出路就是拳头。地下拳场的不败之王，一路打到世界拳王争霸赛的擂台。每一拳不仅是力量的对决，更是命运的博弈。',
    category: 'action',
    tags: ['动作', '格斗', '热血'],
    rating: 4.3,
    views: 780000,
    status: '连载中',
    updateDate: '2026-07-03',
    chapters: [
      { id: 'ch19-1', title: '第1话 街头少年', updateDate: '2026-04-01' },
      { id: 'ch19-2', title: '第2话 地下拳场', updateDate: '2026-04-06' },
      { id: 'ch19-3', title: '第3话 初战告捷', updateDate: '2026-04-11' },
      { id: 'ch19-4', title: '第4话 经纪人', updateDate: '2026-04-16' },
      { id: 'ch19-5', title: '第5话 职业擂台', updateDate: '2026-04-21' },
      { id: 'ch19-6', title: '第6话 宿命的对手', updateDate: '2026-04-26' },
    ],
  },
  {
    id: 'comic-20',
    slug: 'mo-ri-qiu-sheng',
    title: '末日求生',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20apocalypse%20survival%20comic%20cover%2C%20survivors%20in%20ruined%20city%20with%20weapons%2C%20zombie%20silhouettes%20in%20background%2C%20dramatic%20sunset%20sky%2C%20post-apocalyptic%20theme%2C%20clean%20webtoon%20illustration%2C%20orange%20and%20gray%20color%20scheme&width=600&height=800&seq=comic-cover-20&orientation=portrait',
    description: '丧尸病毒爆发三天后，城市变成了人间地狱。一群素不相识的幸存者被困在商场中，食物有限、人心难测。比丧尸更可怕的，是黑暗中的人性之恶。',
    category: 'action',
    tags: ['动作', '丧尸', '生存'],
    rating: 4.6,
    views: 1670000,
    status: '连载中',
    updateDate: '2026-07-07',
    chapters: [
      { id: 'ch20-1', title: '第1话 爆发', updateDate: '2026-05-01' },
      { id: 'ch20-2', title: '第2话 被困', updateDate: '2026-05-05' },
      { id: 'ch20-3', title: '第3话 幸存者', updateDate: '2026-05-09' },
      { id: 'ch20-4', title: '第4话 物资争夺', updateDate: '2026-05-13' },
      { id: 'ch20-5', title: '第5话 背叛', updateDate: '2026-05-17' },
      { id: 'ch20-6', title: '第6话 突围', updateDate: '2026-05-21' },
      { id: 'ch20-7', title: '第7话 安全区', updateDate: '2026-05-25' },
      { id: 'ch20-8', title: '第8话 更大的危险', updateDate: '2026-05-29' },
    ],
  },
  {
    id: 'comic-21',
    slug: 'yi-shi-jie-can-ting',
    title: '异世界餐厅',
    author: '赵恩静',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20isekai%20cooking%20fantasy%20comic%20cover%2C%20chef%20in%20magical%20kitchen%20with%20fantasy%20ingredients%2C%20dragon%20and%20elves%20as%20customers%2C%20warm%20magical%20atmosphere%2C%20whimsical%20theme%2C%20clean%20webtoon%20illustration%2C%20golden%20and%20green%20color%20palette&width=600&height=800&seq=comic-cover-21&orientation=portrait',
    description: '米其林三星主厨在一次意外中穿越到了剑与魔法的异世界。在这个美食文化为零的世界，他决定开一家餐厅！用地球的美食征服异世界种族的胃，顺便拯救一下世界。',
    category: 'fantasy',
    tags: ['奇幻', '美食', '搞笑'],
    rating: 4.9,
    views: 2450000,
    status: '连载中',
    updateDate: '2026-07-08',
    chapters: [
      { id: 'ch21-1', title: '第1话 穿越', updateDate: '2026-03-01' },
      { id: 'ch21-2', title: '第2话 第一道菜', updateDate: '2026-03-06' },
      { id: 'ch21-3', title: '第3话 精灵族客人', updateDate: '2026-03-11' },
      { id: 'ch21-4', title: '第4话 龙族的美食', updateDate: '2026-03-16' },
      { id: 'ch21-5', title: '第5话 国王的邀约', updateDate: '2026-03-21' },
    ],
  },
  {
    id: 'comic-22',
    slug: 'long-zhi-ji-cheng-zhe',
    title: '龙之继承者',
    author: '韩志浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20dragon%20fantasy%20comic%20cover%2C%20young%20hero%20with%20dragon%20scales%20and%20glowing%20eyes%2C%20ancient%20dragon%20in%20background%2C%20epic%20fantasy%20atmosphere%2C%20magical%20energy%2C%20clean%20webtoon%20illustration%2C%20emerald%20and%20gold%20color%20scheme&width=600&height=800&seq=comic-cover-22&orientation=portrait',
    description: '传说中，被龙选中的人将获得毁天灭地的力量。在屠龙盛行的时代，一个少年却选择与濒死的远古巨龙签订契约。从此，人与龙并肩作战，共同对抗整个世界的恶意。',
    category: 'fantasy',
    tags: ['奇幻', '龙', '冒险'],
    rating: 4.7,
    views: 1320000,
    status: '连载中',
    updateDate: '2026-07-06',
    chapters: [
      { id: 'ch22-1', title: '第1话 屠龙节', updateDate: '2026-04-01' },
      { id: 'ch22-2', title: '第2话 密林深处', updateDate: '2026-04-06' },
      { id: 'ch22-3', title: '第3话 契约', updateDate: '2026-04-11' },
      { id: 'ch22-4', title: '第4话 初次并肩', updateDate: '2026-04-16' },
      { id: 'ch22-5', title: '第5话 龙骑士', updateDate: '2026-04-21' },
      { id: 'ch22-6', title: '第6话 帝国军', updateDate: '2026-04-26' },
      { id: 'ch22-7', title: '第7话 龙之谷', updateDate: '2026-05-01' },
    ],
  },
  {
    id: 'comic-23',
    slug: 'jing-ling-sen-lin-de-mi-mi',
    title: '精灵森林的秘密',
    author: '柳多美',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fairy%20fantasy%20comic%20cover%2C%20elf%20girl%20in%20enchanted%20forest%20with%20glowing%20plants%2C%20magical%20creatures%2C%20dreamy%20atmosphere%2C%20mystical%20theme%2C%20clean%20webtoon%20illustration%2C%20soft%20green%20and%20lavender%20color%20palette&width=600&height=800&seq=comic-cover-23&orientation=portrait',
    description: '一个人类女孩意外踏入了地图上不存在的精灵森林。在这里，她遇到了精灵族的王子，发现了隐藏在森林深处的古老秘密。一场关于守护与牺牲的奇幻冒险开始了。',
    category: 'fantasy',
    tags: ['奇幻', '精灵', '冒险'],
    rating: 4.5,
    views: 960000,
    status: '已完结',
    updateDate: '2026-06-25',
    chapters: [
      { id: 'ch23-1', title: '第1话 迷路', updateDate: '2026-03-01' },
      { id: 'ch23-2', title: '第2话 精灵王子', updateDate: '2026-03-06' },
      { id: 'ch23-3', title: '第3话 生命之树', updateDate: '2026-03-11' },
      { id: 'ch23-4', title: '第4话 黑暗侵袭', updateDate: '2026-03-16' },
      { id: 'ch23-5', title: '第5话 最终话 新的守护者', updateDate: '2026-03-21' },
    ],
  },
  {
    id: 'comic-24',
    slug: 'xi-xie-gui-ri-ji',
    title: '吸血鬼日记',
    author: '安宰贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20vampire%20fantasy%20comic%20cover%2C%20handsome%20vampire%20in%20gothic%20mansion%2C%20moonlight%20through%20stained%20glass%2C%20dark%20romantic%20atmosphere%2C%20supernatural%20theme%2C%20clean%20webtoon%20illustration%2C%20blood%20red%20and%20midnight%20blue%20color%20scheme&width=600&height=800&seq=comic-cover-24&orientation=portrait',
    description: '活了五百年的纯血吸血鬼，在现代首尔过着低调的生活。直到一个人类女孩搬进了他的公寓隔壁，她身上流淌的血液竟散发着让他无法抗拒的致命诱惑。一段跨越种族的禁忌之恋。',
    category: 'fantasy',
    tags: ['奇幻', '吸血鬼', '恋爱'],
    rating: 4.6,
    views: 1540000,
    status: '连载中',
    updateDate: '2026-07-05',
    chapters: [
      { id: 'ch24-1', title: '第1话 新邻居', updateDate: '2026-04-01' },
      { id: 'ch24-2', title: '第2话 鲜血的诱惑', updateDate: '2026-04-06' },
      { id: 'ch24-3', title: '第3话 猎人的追杀', updateDate: '2026-04-11' },
      { id: 'ch24-4', title: '第4话 他的过去', updateDate: '2026-04-16' },
      { id: 'ch24-5', title: '第5话 血族议会', updateDate: '2026-04-21' },
      { id: 'ch24-6', title: '第6话 选择', updateDate: '2026-04-26' },
    ],
  },
  {
    id: 'comic-25',
    slug: 'xin-li-you-xi',
    title: '心理游戏',
    author: '文志勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20psychological%20thriller%20comic%20cover%2C%20man%20in%20dark%20room%20with%20chess%20board%2C%20tense%20atmosphere%2C%20split%20personality%20theme%2C%20mind%20games%2C%20clean%20webtoon%20illustration%2C%20black%20white%20and%20red%20color%20scheme&width=600&height=800&seq=comic-cover-25&orientation=portrait',
    description: '十名陌生人被关在一栋密闭建筑中，一个神秘的声音宣布游戏规则：每24小时投票处决一人，直到只剩最后一人。在死亡的压力下，人性最黑暗的一面开始显露。',
    category: 'thriller',
    tags: ['悬疑', '心理', '生存'],
    rating: 4.7,
    views: 1380000,
    status: '已完结',
    updateDate: '2026-06-28',
    chapters: [
      { id: 'ch25-1', title: '第1话 醒来', updateDate: '2026-04-01' },
      { id: 'ch25-2', title: '第2话 规则', updateDate: '2026-04-04' },
      { id: 'ch25-3', title: '第3话 第一次投票', updateDate: '2026-04-07' },
      { id: 'ch25-4', title: '第4话 联盟与背叛', updateDate: '2026-04-10' },
      { id: 'ch25-5', title: '第5话 幕后黑手', updateDate: '2026-04-14' },
      { id: 'ch25-6', title: '第6话 最终话 真相', updateDate: '2026-04-18' },
    ],
  },
  {
    id: 'comic-26',
    slug: 'di-qi-ge-mu-ji-zhe',
    title: '第7个目击者',
    author: '尹智敏',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20crime%20thriller%20comic%20cover%2C%20detective%20in%20rainy%20alley%20at%20night%2C%20crime%20scene%20tape%2C%20police%20car%20lights%2C%20murder%20mystery%20theme%2C%20clean%20webtoon%20illustration%2C%20dark%20blue%20and%20yellow%20neon%20color%20scheme&width=600&height=800&seq=comic-cover-26&orientation=portrait',
    description: '一桩连环杀人案，前六名目击者全部离奇死亡。当第七个目击者出现时，刑警崔敏俊必须在凶手之前找到她。但随着调查深入，他发现案件背后隐藏着一个长达二十年的复仇计划。',
    category: 'thriller',
    tags: ['悬疑', '犯罪', '推理'],
    rating: 4.8,
    views: 1760000,
    status: '连载中',
    updateDate: '2026-07-07',
    chapters: [
      { id: 'ch26-1', title: '第1话 第六个死者', updateDate: '2026-05-01' },
      { id: 'ch26-2', title: '第2话 唯一的证人', updateDate: '2026-05-06' },
      { id: 'ch26-3', title: '第3话 追查', updateDate: '2026-05-11' },
      { id: 'ch26-4', title: '第4话 二十年前的案子', updateDate: '2026-05-16' },
      { id: 'ch26-5', title: '第5话 嫌疑人的自白', updateDate: '2026-05-21' },
      { id: 'ch26-6', title: '第6话 新的受害者', updateDate: '2026-05-26' },
    ],
  },
  {
    id: 'comic-27',
    slug: 'ji-yi-sui-pian',
    title: '记忆碎片',
    author: '李瑞元',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mystery%20thriller%20comic%20cover%2C%20woman%20surrounded%20by%20floating%20broken%20mirror%20fragments%2C%20surreal%20dreamlike%20atmosphere%2C%20memory%20loss%20theme%2C%20clean%20webtoon%20illustration%2C%20soft%20blue%20and%20white%20color%20palette&width=600&height=800&seq=comic-cover-27&orientation=portrait',
    description: '一场车祸后，她失去了过去三年的全部记忆。身边的人都声称是她的亲人朋友，但她总觉得有什么地方不对劲。零碎的记忆闪回中，她发现了一个令人毛骨悚然的事实——她可能不是她自己。',
    category: 'thriller',
    tags: ['悬疑', '失忆', '反转'],
    rating: 4.5,
    views: 1120000,
    status: '连载中',
    updateDate: '2026-07-06',
    chapters: [
      { id: 'ch27-1', title: '第1话 苏醒', updateDate: '2026-05-01' },
      { id: 'ch27-2', title: '第2话 熟悉又陌生', updateDate: '2026-05-06' },
      { id: 'ch27-3', title: '第3话 日记本', updateDate: '2026-05-11' },
      { id: 'ch27-4', title: '第4话 双胞胎', updateDate: '2026-05-16' },
      { id: 'ch27-5', title: '第5话 真相浮现', updateDate: '2026-05-21' },
    ],
  },
  {
    id: 'comic-28',
    slug: 'shen-yuan-zhi-yan',
    title: '深渊之眼',
    author: '金敏俊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20horror%20thriller%20comic%20cover%2C%20single%20glowing%20eye%20in%20darkness%2C%20eldritch%20cosmic%20horror%20theme%2C%20creepy%20atmosphere%2C%20supernatural%20terror%2C%20clean%20webtoon%20illustration%2C%20pitch%20black%20and%20sickly%20green%20color%20scheme&width=600&height=800&seq=comic-cover-28&orientation=portrait',
    description: '国家地震局监测到深海之下有巨大生命体在移动。一支科考队在海底深渊发现了远古文明遗迹，以及一只从未闭合的眼睛。当这只眼睛睁开时，全人类的噩梦开始了。',
    category: 'thriller',
    tags: ['悬疑', '克苏鲁', '恐怖'],
    rating: 4.4,
    views: 890000,
    status: '连载中',
    updateDate: '2026-07-04',
    chapters: [
      { id: 'ch28-1', title: '第1话 深海信号', updateDate: '2026-05-01' },
      { id: 'ch28-2', title: '第2话 下潜', updateDate: '2026-05-06' },
      { id: 'ch28-3', title: '第3话 古城遗迹', updateDate: '2026-05-11' },
      { id: 'ch28-4', title: '第4话 睁开眼睛', updateDate: '2026-05-16' },
      { id: 'ch28-5', title: '第5话 感染', updateDate: '2026-05-21' },
    ],
  },
  {
    id: 'comic-29',
    slug: 'dian-jing-zhi-wang',
    title: '电竞之王',
    author: '都暻秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20esports%20gaming%20comic%20cover%2C%20young%20pro%20gamer%20with%20headset%20in%20arena%20with%20holographic%20screens%2C%20competitive%20atmosphere%2C%20cyber%20theme%2C%20clean%20webtoon%20illustration%2C%20neon%20cyan%20and%20purple%20color%20scheme&width=600&height=800&seq=comic-cover-29&orientation=portrait',
    description: '被誉为天才少年的他，十六岁就站上了世界电竞之巅。然而冠军光环下，是队友的嫉妒、教练的压榨、粉丝的期待。从巅峰跌落后，他如何重新站起，再次证明自己是真正的电竞之王？',
    category: 'action',
    tags: ['动作', '电竞', '竞技'],
    rating: 4.6,
    views: 2010000,
    status: '连载中',
    updateDate: '2026-07-08',
    chapters: [
      { id: 'ch29-1', title: '第1话 天才少年', updateDate: '2026-04-01' },
      { id: 'ch29-2', title: '第2话 青训队', updateDate: '2026-04-05' },
      { id: 'ch29-3', title: '第3话 第一次登场', updateDate: '2026-04-09' },
      { id: 'ch29-4', title: '第4话 连败', updateDate: '2026-04-13' },
      { id: 'ch29-5', title: '第5话 队内矛盾', updateDate: '2026-04-17' },
      { id: 'ch29-6', title: '第6话 转会风波', updateDate: '2026-04-21' },
      { id: 'ch29-7', title: '第7话 世界赛', updateDate: '2026-04-25' },
    ],
  },
  {
    id: 'comic-30',
    slug: 'qian-nian-zhi-lian',
    title: '千年之恋',
    author: '张美兰',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20eternal%20love%20fantasy%20comic%20cover%2C%20star-crossed%20couple%20across%20ancient%20and%20modern%20eras%2C%20time%20portal%20effect%2C%20romantic%20and%20melancholic%20atmosphere%2C%20clean%20webtoon%20illustration%2C%20soft%20pink%20and%20gold%20color%20palette&width=600&height=800&seq=comic-cover-30&orientation=portrait',
    description: '千年前的神女与凡人将军相爱，触犯天条被罚永世分离。千年后的现代，将军的转世成为考古学家，在一座古墓中发现了神女的壁画。跨越千年的思念，是否能在这一世圆满？',
    category: 'fantasy',
    tags: ['奇幻', '恋爱', '转世'],
    rating: 4.9,
    views: 2680000,
    status: '已完结',
    updateDate: '2026-07-01',
    chapters: [
      { id: 'ch30-1', title: '第1话 天界之罚', updateDate: '2026-04-01' },
      { id: 'ch30-2', title: '第2话 千年之后', updateDate: '2026-04-06' },
      { id: 'ch30-3', title: '第3话 古墓壁画', updateDate: '2026-04-11' },
      { id: 'ch30-4', title: '第4话 前世记忆', updateDate: '2026-04-16' },
      { id: 'ch30-5', title: '第5话 神界使者', updateDate: '2026-04-21' },
      { id: 'ch30-6', title: '第6话 最终话 千年之约', updateDate: '2026-04-26' },
    ],
  },
];

export const categories: Record<string, { name: string; icon: string; description: string }> = {
  all: { name: '全部', icon: 'ri-apps-line', description: '浏览全部韩漫作品' },
  love: { name: '恋爱', icon: 'ri-heart-line', description: '浪漫甜蜜的爱情故事' },
  action: { name: '动作', icon: 'ri-sword-line', description: '热血沸腾的动作漫画' },
  fantasy: { name: '奇幻', icon: 'ri-magic-line', description: '奇幻世界的冒险之旅' },
  thriller: { name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑故事' },
};

export const categoryMeta = categories;

export const categorySlugs = ['all', 'love', 'action', 'fantasy', 'thriller'];
